var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOilIndustryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oil-industry_icon 1",
    clipPath: "url(#clip0_2999_1425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "oil-industry_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "oil_industry"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 30C0 13.432 13.432 0 30 0C46.568 0 60 13.432 60 30C60 46.568 46.568 60 30 60C13.432 60 0 46.568 0 30Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "animi"
  }, /*#__PURE__*/React.createElement("path", {
    id: "oil_drop",
    d: "M12 33.2C12 31.6539 9.5 29 9.5 29C9.5 29 7 31.6539 7 33.2C7 34.7461 8.1192 36 9.5 36C10.8809 36 12 34.7461 12 33.2Z",
    stroke: "#1F1F1F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tower"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.494 22.7914L26.3293 21.8984L22.6335 47.5404L24.948 47.5409L28.494 22.7914Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.915 47.5477L32.0194 42.3335L26.3311 37.9538L26.7796 34.7188L30.9937 32.0859L32.6219 33.6982L28.1663 36.5286L33.6505 40.716L34.0645 43.6445L28.6568 47.568L24.915 47.5477Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.6291 47.5501L36.9183 47.5401L33.6558 24.9091L30.2521 23.5312L28.1536 25.3364L31.4503 25.511L34.6291 47.5501Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.439 25.5522L28.8314 27.732L32.1208 30.1294L32.5933 33.7357L31.0166 32.126L27.5642 29.564L28.1447 25.3477L31.439 25.5522Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "hamer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.1401 15.2281L26.8568 11.5664C27.3113 10.7905 27.3548 10.118 26.8302 9.58846C24.1034 8.43536 21.404 7.28907 18.3952 6.06586C17.9471 5.98618 17.5002 5.80466 17.0454 6.31814C14.7499 11.7893 13.4128 17.474 12.7277 23.305C12.7104 23.7461 12.6926 24.1924 12.9893 24.4265L16.9913 26.1279C17.4291 26.2271 17.7504 26.1485 17.9942 25.9518C19.3932 24.1193 20.8001 22.1781 22.2106 20.186L44.1046 29.2502C44.823 29.3731 45.0791 29.0171 45.3365 28.7188L46.8134 25.1515C46.8757 24.6411 46.7137 24.2793 46.3717 24.0367L25.1401 15.2281Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M43.8742 29.1567L41.7748 28.3008L41.7952 36.8344L39.4839 36.8299C39.2308 36.9211 39.0514 37.0008 39.021 37.3525L39.0251 47.5542L46.6121 47.5353L46.611 37.2496C46.518 36.8862 46.3175 36.8216 46.1314 36.8086L43.8395 36.8081L43.8742 29.1567Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "base",
    d: "M13.9572 47.5745L46.9712 47.5547C47.5062 47.5774 47.6282 47.9935 47.746 48.4136L47.7422 53.2068C47.6742 53.6768 47.3991 53.9497 46.9529 54.0599L14.0659 54.0514C13.6007 53.9296 13.3777 53.6134 13.33 53.1886L13.3242 48.4462C13.4063 48.0581 13.5901 47.7469 13.9575 47.5744L13.9572 47.5745Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeOpacity: 0.6737,
    strokeWidth: 0.093211
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2999_1425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilIndustryIcon);
export default __webpack_public_path__ + "static/media/oil-industry_icon.1681754e10bd7b1741e2647a86ce85f8.svg";
export { ForwardRef as ReactComponent };